
import React, { useState, useEffect } from "react";
import "./UserReports.css";
import { fetchExamResults } from "../../../../api/quizResultApi";
import authService from "../../../../services/authService";

const UserReports = () => {
  const [results, setResults] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 5;

  useEffect(() => {
    document.title = 'Reports - Finhaat Gurukul';
  }, []);

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const userEmail = authService.getUserEmail();
        if (!userEmail) {
          throw new Error('User email not found');
        }
        const fetchedResults = await fetchExamResults(userEmail);

        const sortedResults = fetchedResults.sort((a, b) => b.userExamId - a.userExamId);
        setResults(sortedResults);
        setLoading(false);
      } catch (err) {
        setError("Failed to load results. Please try again later.");
        setLoading(false);
      }
    };

    fetchResults();
  }, []);

  const filterResults = (criteria) => {
    setFilter(criteria);
    setCurrentPage(1);
  };

  const filteredResults = results.filter((result) => {
    if (filter === "all") return true;
    const isPassed = result.score > 0;
    return (filter === "Passed" && isPassed) || (filter === "Failed" && !isPassed);
  });

  const indexOfLastResult = currentPage * resultsPerPage;
  const indexOfFirstResult = indexOfLastResult - resultsPerPage;
  const currentResults = filteredResults.slice(indexOfFirstResult, indexOfLastResult);
  const totalPages = Math.ceil(filteredResults.length / resultsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  if (loading) {
    return (
      <div>
        <div className="spinner-container">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <h2 className='heading-for-training-page-user' style={{ textAlign: 'start' }}>📋 Reports</h2>
      <div className="result-menu">
        <div className="filter-options">
          <button
            className={filter === "all" ? "active" : ""}
            onClick={() => filterResults("all")}
          >
            All
          </button>
          <button
            className={filter === "Passed" ? "active" : ""}
            onClick={() => filterResults("Passed")}
          >
            Passed
          </button>
          <button
            className={filter === "Failed" ? "active" : ""}
            onClick={() => filterResults("Failed")}
          >
            Failed
          </button>
        </div>
        <div className="result-list">
          {currentResults.length > 0 ? (
            currentResults.map((result) => (
              <div key={result.userExamId} className="result-card">
                <div className="result-header">
                  <h3 className="result-header-mock-h3">{result.examTypeDesc}</h3>
                  <h3 className="result-header-mock-h3">{result.examName}</h3>
                </div>
                <div className="result-body">
                  <p className="result-body-score-p">Score: {result.correctAnswers}/{result.totalQuestions}</p>
                  <p className={`result-status ${result.score > 0 ? "passed" : "failed"}`}>
                    {result.score > 0 ? "Passed" : "Failed"}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="no-results-found-users">No results found.</p>
          )}
        </div>
        {/* <div className="pagination-for-user-reports">
        <button 
          className="pagination-for-user-reports-pagination-button" 
          onClick={handlePreviousPage} 
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button 
          className="pagination-for-user-reports-pagination-button" 
          onClick={handleNextPage} 
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div> */}

        {filteredResults.length > 0 && (
          <div className="pagination-for-user-reports">
            <button
              className="pagination-for-user-reports-pagination-button"
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="pagination-for-user-reports-pagination-button"
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default UserReports;